import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// API
import * as API from '../../utils/api';

// Components
import Header from '../../components/Global/Header';
import FormContainer from '../../components/Global/FormContainer';
import FormInput from '../../components/Global/Forms/FormInput';
import FlashMessage from '../../components/Global/FlashMessage';

// Utils
import {
  validateEmail,
} from '../../utils/helpers';

class ResetPassword extends Component {

  state = {
    input: {
      email: '',
      password: '',
      password_confirm: '',
    },
    formErrors: {
      email: '',
      password: '',
      password_confirm: '',
    },
    formIsValid: false,
    displayErrorMessages: false,
    flashMessage: {
      display: false,
      message: '',
      type: '',
    },
    token: '',
    passwordResetSuccessful: false,
    isLoggedIn: false,
  }

  componentDidMount() {
    const { token } = this.props.match.params;
    const { user } = this.props;

    this.setState(state => ({
      input: {
        ...state.input,
        email: user.isLoggedIn ? user.email : ''
      },
      token: token,
      isLoggedIn: user.isLoggedIn,
    }))
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      },
      logInErrorMessage: ''
    }), () => { this.updateFieldErrorMessage(name, value) });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { input, token } = this.state;

    if (this.isFormValid()) {
      API.updatePassword(token, input.email, input.password)
        .then(response => {
          if (response.success) {
            this.setState({
              flashMessage: {
                display: true,
                message: 'Your password has been updated successfully.',
                type: '',
              },
              passwordResetSuccessful: true
            })

          } else if (response.errors.includes("Email doesn't match")) {
            this.setState({
              flashMessage: {
                display: true,
                message: `${input.email} does not exist in our system. Please try again.`,
                type: 'error',
              }
            })
          } else {
            this.setState({
              flashMessage: {
                display: true,
                message: 'An error occured. Please try again.',
                type: 'error',
              }
            })
          }
        })

    } else {
      this.setFormErrorState();
    }
  }

  setFormErrorState = () => {
    const { input, displayErrorMessages } = this.state;

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  turnOnErrorMessages() {
    this.setState(state => ({
      ...state,
      displayErrorMessages: true
    }));
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state;

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }));
  }

  isFormValid() {
    const { input } = this.state;

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      return this.isFieldValid(field, input[field])
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false;
    } else {
      return true;
    }
  }

  isFieldValid = (fieldName, value) => {
    const { input } = this.state;

    switch(fieldName) {
      case 'email':
        return validateEmail(value)
        // eslint-disable-next-line no-unreachable
        break;
      case 'password_confirm':
        return value.length > 0 && value === input.password ? true : false;
        // eslint-disable-next-line no-unreachable
        break;
      default:
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  updateFieldErrorMessage = (fieldName, value) => {
    const { input } = this.state;
    let errorMessage = '';

    switch(fieldName) {
      case 'email':
        errorMessage = validateEmail(value)
          ? ''
          : 'Please enter a valid email'
        break;
      case 'password_confirm':
        errorMessage = value === input.password && value.length > 0
        ? ''
        : 'Please make sure passwords match';
        break;
      default:
        errorMessage = value.length > 0
          ? ''
          : 'Please complete this field';
        break;
    }

    this.setState(state => ({
      ...state,
      formErrors: {
        ...state.formErrors,
        [fieldName]: errorMessage
      }
    }));
  }

  handleInputBlur = (event) => {
    const { value, name } = event.target;
    const { formIsValid, displayErrorMessages } = this.state;

    this.updateFieldErrorMessage(name, value);

    if (!formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  renderFlashMessage() {
    const { flashMessage } = this.state;

    return flashMessage.display
    ? (
      <FlashMessage
        optionalClasses={`${flashMessage.type === 'error' ? 'error' : ''}`}
      >
        {flashMessage.message}
      </FlashMessage>
    )
    : ''
  }

  renderChoosePasswordInstructions() {
    const { isLoggedIn } = this.state;

    return isLoggedIn
    ? (
      <p>
        Enter and confirm a new password below.
      </p>
    )
    : (
      <p>
        Enter the email associated with your account and a new password to save changes.
      </p>
    )
  }

  renderChoosePasswordForm() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      flashMessage,
      isLoggedIn
    } = this.state;

    return flashMessage.display && flashMessage.type !== 'error'
    ? null
    : (
      <form onSubmit={this.handleSubmit}>
        {!isLoggedIn &&
          <FormInput
            label="Email Address"
            placeholder="Email Address"
            name="email"
            type="email"
            value={input.email}
            onChange={this.handleInputChange}
            onBlur={this.handleInputBlur}
            showError={displayErrorMessages}
            errorMessage={formErrors.email}
          />
        }
        <FormInput
          label="Password"
          placeholder="Password"
          name="password"
          type="password"
          value={input.password}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.password}
        />
        <FormInput
          label="Confirm Password"
          placeholder="Confirm Password"
          name="password_confirm"
          type="password"
          value={input.password_confirm}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.password_confirm}
        />
        <hr />
        <input type="submit" value="Update Password" />
      </form>
    )
  }

  render() {
    const {
      appName,
      path,
      user
    } = this.props;

    const { passwordResetSuccessful, isLoggedIn } = this.state;

    return (
      <div className={`onboarding reset-password${user.isLoggedIn ? ' authenticated' : ''}`}>
        <Helmet>
          <title>{appName} | Choose Your Password</title>
        </Helmet>
        <Header path={ path }/>
        <FormContainer>
          <header>
            <h2>Choose Password</h2>
            {!passwordResetSuccessful && this.renderChoosePasswordInstructions()}
          </header>
          {this.renderFlashMessage()}
          {!passwordResetSuccessful && this.renderChoosePasswordForm()}
          {passwordResetSuccessful && !isLoggedIn &&
            <div className="post-form-link">
              <Link to="/log-in" className="cta full-width">
                Continue to Log In
              </Link>
            </div>
          }
        </FormContainer>
      </div>
    );
  }
}

const mapStateToProps =  state  => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  null
)(ResetPassword)



// WEBPACK FOOTER //
// ./src/screens/Sessions/ChoosePassword.js